const DEFAULTS = {
  uiSettingsConfig: {
    enabledProperties: true,
    enabledColorCode: false,
    enabledIot: false,
    enabledFilter: false,
  },
  customTabsConfig: [
    {
      name: "Test tab",
      properties: ["Absorptance", "Area", "Category", "Test"],
    },
  ],
  navigationConfig: {
    "Name": "Navigation",
    "Filters": [
      {
        "Name": "Level 0",
        "Operation": "Or",
        "Conditions": [
          {
            "Property": "Base *",
            "Value": "Level 0"
          },
          {
            "Property": "Level",
            "Value": "Level 0"
          }
        ]
      },
      {
        "Name": "Level 1",
        "Operation": "Or",
        "Conditions": [
          {
            "Property": "*",
            "Value": "Level 1"
          }
        ]
      },
      {
        "Name": "Level 2",
        "Operation": "Or",
        "Conditions": [
          {
            "Property": "*",
            "Value": "Level 2"
          }
        ]
      }
    ]
  },
  viewTemplatesConfig: {
    "Name": "View Templates",
    "Definitions": [
      {
        "Name": "GA Plan",
        "Colors": {
          "Fallback": "Gray",
          "Operation": "Or",
          "Conditions": [
            {
              "Property": "Category",
              "Value": "Rooms"
            },
            {
              "Property": "Category",
              "Value": "Walls"
            },
            {
              "Property": "Category",
              "Value": "Site"
            }
          ],
          "Values": [
            {
              "Property": "*Category*",
              "Value": "Rooms",
              "Color": "#0000ff"
            },
            {
              "Property": "Category",
              "Value": "Walls",
              "Color": "#ff0000"
            },
            {
              "Property": "Category",
              "Value": "Site",
              "Color": "#00ff00"
            }
          ]
        },
        "Tags": {
          "Operation": "And",
          "Conditions": [
            {
              "Property": "Category",
              "Value": "Rooms"
            }
          ],
          "Color": "#bbb",
          "Properties": [
            {
              "Name": "Number",
              "Size": "1em",
              "Format": "{0} - "
            },
            {
              "Name": "Name",
              "Size": "1em",
              "Format": "{0}\n"
            },
            {
              "Name": "Area",
              "Size": "2em",
              "Format": "{0} m"
            }
          ]
        }
      },
      {
        "Name": "Fire Strategy",
        "Colors": {
          "Fallback": "SteelBlue",
          "Operation": "Or",
          "Conditions": [
            {
              "Property": "Category",
              "Value": "Rooms"
            },
            {
              "Property": "Category",
              "Value": "Doors"
            }
          ],
          "Values": [
            {
              "Property": "Fire Rating",
              "Value": "30 min",
              "Color": "0000ff"
            },
            {
              "Property": "Fire Rating",
              "Value": "60 min",
              "Color": "ff0000"
            },
            {
              "Property": "Fire Rating",
              "Value": "90 min",
              "Color": "00ff00"
            }
          ]
        },
        "Tags": {
          "Operation": "Or",
          "Conditions": [
            {
              "Property": "Category",
              "Value": "Rooms"
            },
            {
              "Property": "Category",
              "Value": "Doors"
            }
          ],
          "Color": "bada55",
          "Properties": [
            {
              "Name": "Category",
              "Size": "2em",
              "Format": "{0}"
            }
          ]
        }
      }
    ]
  }
};

export default DEFAULTS;
